import Vue from "vue"

const path = "qr"

export default {
    sideDMS(data) {
        return Vue.prototype.$http.post(`${path}/side-dms`, data)
    },
}
